import React, {Fragment, useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Pager from "../../common/pager";
import {postSaveContracts} from "../../../api/contract-api";
import ContractsContext from "./contractsContext";
import {changeContractsPage} from "./contractsFunctions";
import {getFirstUnfilledCustomField} from "./contractsFieldsFunctions";
import {renderErrorPopup} from "../../../api/api-popups";

const ContractsPopupFooter = (props) => {

  const {intl, changeContext, contractsList, contractsValues} = props;

  const context = useContext(ContractsContext);
  const {totalPages, globalContractPage} = context;

  const onPagerClick = (page, newContext) => {
    changeContractsPage(page, contractsList, newContext || context, changeContext)
  }

  const nextClick = () => {
    if (globalContractPage < totalPages) {
      onPagerClick(globalContractPage + 1);
      return
    }
    const firstUnFilledCustomField = getFirstUnfilledCustomField(contractsValues, contractsList);
    if (firstUnFilledCustomField.page !== -1) {
      renderErrorPopup(intl.formatMessage({ id: "contractSign.errorFieldsPopupMessage" }), "", nextClick.bind(this), false, () => {
        setTimeout(() => {
          const newContext = {
            ...context,
            pageRendered: globalContractPage === firstUnFilledCustomField.page,
            selectedFieldIndex: firstUnFilledCustomField.fieldIndex
          }
          changeContext(newContext);
          onPagerClick(firstUnFilledCustomField.page, newContext)
        }, 300);
      });
      return;
    }
    postSaveContracts(nextClick.bind(this));
  }

  return (
    <Fragment>
      <Pager totalPages={totalPages}
             pageClick={onPagerClick}
             page={globalContractPage - 1}/>
      <div className="contract-footer">
        <button className="ui-button3 ui-button--3 ui-button3--green ui-button3--wide"
                onClick={nextClick}>
           <FormattedMessage id={globalContractPage < totalPages
             ? "contractSign.footerNextButton"
             : "contractSign.footerFinishButton"}/>
        </button>
      </div>
    </Fragment>
  )
};

ContractsPopupFooter.propTypes = {
  changeContext: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {contractsList, contractsValues} = store.contractSigningState;
  return {
    contractsList,
    contractsValues,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContractsPopupFooter)
)
